import React from 'react';
import { FovLoader } from 'components';

export const IndeterminateProgress = props => {
  const { ...rest } = props;

  return (
    <FovLoader resource={false} text={props.text} {...rest} />
  );
};